<template>
  <div>
    <div class="form-grey-box mt-3" v-if="carregando && !erroBuscaLimite">
      <v-layout row wrap>
        <v-flex xs1 mt-5>
          <v-progress-circular
            indeterminate
            color="#282498"
          ></v-progress-circular>
        </v-flex>
        <v-flex xs11 mt-3>
          <label class="header"
            >Calculando limites e taxas para este tomador</label
          >
          <div class="subheader">
            <h3>
              Este processo pode levar alguns minutos, aguarde enquanto
              realizamos este procedimento.
            </h3>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="form-grey-box" v-if="!carregando && erroBuscaLimite">
      <v-layout row wrap>
        <v-flex xs12 mt-3>
          <div class="subheader">
            <h3 v-html="msgErroBuscaLimite"></h3>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="!carregando && !erroBuscaLimite">
      <!-- Tabela de limites e taxas do tomador -->
      <taxas-limites
        :taker="taker"
        :step="step"
        :tipo_pessoa="tipo_pessoa"
        :id_grupo="id_grupo"
      />
      <!-- ./Tabela de limites e taxas do tomador -->
    </div>
  </div>
</template>

<style lang='scss' scoped>
.form-grey-box {
  padding: 25px;
  padding-bottom: 0px;
  width: 100%;
  position: relative;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  background-color: #f7f7f7;
  font-weight: bold;
  position: relative;
  height: 176px;
}
.header {
  font-size: 1.3vw;
  font-weight: 600;
}
.subheader {
  padding-top: 0.8vw;
  font-weight: 200;
}
</style>

<script lang="js">
export default {
  name: "LimitesTaxas",
  props: [
    "carregando",
    "erroBuscaLimite",
    "msgErroBuscaLimite",
    "taker",
    "step",
    "tipo_pessoa",
    "id_grupo",
  ],
};
</script>





// WEBPACK FOOTER //
// ./src/components/LimitesTaxas.vue